import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from '@/lib/i18n/react';
import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';
import { isCurrentMessageOwner } from '../message-cache';
import { useMessageActionState, reviewMessageAction, acceptMessageReview, clearMessageFailure } from '../message-actions';
import { localizedErrorMessage } from '@/lib/i18n/errors';

/** Observations never turn a lost response into a successful receipt. */
export function MessageWriteReview({channelId}:{channelId:string}) {
  const {t}=useTranslation('teamchat'),qc=useQueryClient();
  useAuthStore(sessionScope);
  const action=useMessageActionState(state=>state.actions[channelId]);
  const failure=useMessageActionState(state=>state.failures[channelId]);
  if(!action)return failure?<div role="alert" className="m-2 flex flex-wrap items-center gap-2 p-2 text-xs text-red-600">
    <span>{localizedErrorMessage(failure,'teamchat','write.unconfirmed')}</span>
    <button type="button" className="btn btn-secondary min-h-11" onClick={()=>clearMessageFailure(channelId)}>{t('view.shared.inbox.proposal.dismiss')}</button>
  </div>:null;
  if(!isCurrentMessageOwner(action.owner)||action.phase==='pending')return null;
  return <div role="status" className="m-2 flex flex-wrap items-center gap-2 rounded-lg border border-amber-400/50 bg-amber-50 p-3 text-xs text-amber-950">
    <span>{t(action.phase==='reviewed'?'write.reviewed':action.failed?'write.review_failed':'write.unconfirmed')}</span>
    <button className="btn btn-secondary min-h-11" type="button" disabled={action.phase==='reviewing'} onClick={()=>void reviewMessageAction(qc,channelId).catch(()=>{})}>
      {t(action.phase==='reviewing'?'write.reviewing':'write.review')}
    </button>
    {action.phase==='reviewed'&&<button className="btn btn-secondary min-h-11" type="button" onClick={()=>acceptMessageReview(channelId)}>{t('write.accept')}</button>}
  </div>;
}
